export const screenIsActive = (screens: any, screen: string) => {
  return (
    Object.keys(Object.fromEntries(Object.entries(screens).filter(([, value]) => value))).indexOf(
      screen
    ) !== -1
  );
};

export const sortAlphabetically = (a: any, b: any) => {
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }
  return 0;
};

export const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

export const allowOnlyNumbers = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.ctrlKey || e.metaKey) {
    return;
  } else {
    if (isNaN(parseInt(e.key, 10)) || parseInt(e.key, 10) < 0 || parseInt(e.key) > 9) {
      if (e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
        e.preventDefault();
      }
    }
  }
};

export const roundToTwo = (num: number) => {
  // @ts-ignore
  return +(Math.round(num + 'e+2') + 'e-2');
};

export const formatNumberWithComma = (value: string) => {
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export function truncate(str, maxlength) {
  return str.length > maxlength ? str.slice(0, maxlength - 1) + '…' : str;
}

export const getVehicleThumb = (vehicle: Vehicle) =>
  vehicle.gallery && vehicle.gallery.data && vehicle.gallery.data[0]
    ? vehicle.gallery.data[0].thumb
    : '';

export const inputHasValue = (value) => value !== null && value !== undefined && value !== '';

export const allowDecimalPlaces = (decimalPlaces: number) => (e: React.KeyboardEvent<HTMLInputElement>) => {
  const char = e.key;
  const currentValue = e.currentTarget.value;
  
  // Allow numbers, one decimal point, backspace, delete, and arrow keys
  if (!/[\d.]/.test(char) && !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
    e.preventDefault();
    return;
  }
  
  // Prevent multiple decimal points
  if (char === '.' && currentValue.includes('.')) {
    e.preventDefault();
    return;
  }
  
  // Prevent more than specified decimal places
  const decimalIndex = currentValue.indexOf('.');
  if (decimalIndex !== -1 && currentValue.length - decimalIndex > decimalPlaces && /\d/.test(char)) {
    e.preventDefault();
    return;
  }
};
